'use client';
import { MenuItemStyled } from './menu-item-styles';

const MenuItem = MenuItemStyled;

export default MenuItem;
